__turbopack_context__.v({
  "buttonsClass": "OurCustomerSays-module-scss-module__WO0Ovq__buttonsClass",
  "carouselActive": "OurCustomerSays-module-scss-module__WO0Ovq__carouselActive",
  "carouselItem": "OurCustomerSays-module-scss-module__WO0Ovq__carouselItem",
  "carouselRow": "OurCustomerSays-module-scss-module__WO0Ovq__carouselRow",
  "customerSaysRow": "OurCustomerSays-module-scss-module__WO0Ovq__customerSaysRow",
  "customersSaysSection": "OurCustomerSays-module-scss-module__WO0Ovq__customersSaysSection",
  "heading": "OurCustomerSays-module-scss-module__WO0Ovq__heading",
  "imgBox": "OurCustomerSays-module-scss-module__WO0Ovq__imgBox",
  "main": "OurCustomerSays-module-scss-module__WO0Ovq__main",
  "nextBtn": "OurCustomerSays-module-scss-module__WO0Ovq__nextBtn",
  "prevBtn": "OurCustomerSays-module-scss-module__WO0Ovq__prevBtn",
  "textCol": "OurCustomerSays-module-scss-module__WO0Ovq__textCol",
});
